import { Component, Vue, Watch } from 'vue-property-decorator';
import Navigation from '@/components/Navigation/Navigation';

@Component<App>({
  components: {
    Navigation,
  },
  // beforeRouteUpdate(to, from, next) {
  //   next();

  //   this.routeName = this.$route.name;
  // },
})
export default class App extends Vue {

  public mounted() {
    //
  }

  protected showNavigation() {
    // if (this.$route.name === 'login') return false;
    if (this.$route.name === 'root') return false;
    // if (this.$route.name === 'worldmap') return false;
    if (this.$route.name === 'login') return false;
    return true;
  }
}
